import { roleOf } from '../utils/role';
import type { Member, SessionUser, UserRole } from '../types';
import { SESSION_KEY } from '../constants/session';

/** sessionStorage에는 memberId만 보관한다. role/duty는 절대 신뢰하지 않는다. */
export interface StoredSession {
  memberId: string;
}

export function buildSessionUser(member: Pick<Member, 'id' | 'name' | 'duty' | 'department' | 'isAdmin'>): SessionUser {
  return {
    id: member.id,
    name: member.name,
    duty: member.duty,
    department: member.department,
    role: roleOf(member),
  };
}

export function readStoredMemberId(): string | null {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    // 구버전: 전체 SessionUser를 저장하던 형식 호환
    if (data && typeof data.memberId === 'string') return data.memberId;
    if (data && typeof data.id === 'string') return data.id;
    return null;
  } catch {
    return null;
  }
}

export function writeStoredMemberId(memberId: string): void {
  try {
    const payload: StoredSession = { memberId };
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(payload));
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearStoredSession(): void {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* ignore */
  }
}

export function sessionLooksStale(prev: SessionUser | null, next: SessionUser): boolean {
  if (!prev) return true;
  return (
    prev.role !== next.role ||
    prev.duty !== next.duty ||
    prev.department !== next.department ||
    prev.name !== next.name
  );
}

export function hasRole(session: SessionUser | null | undefined, allowed: UserRole[]): boolean {
  return !!session && allowed.includes(session.role);
}
